export default {
  position: {
    notes: 'Position for an exciter',
    message: 'Position',
    values: {
      EBCC: {
        notes: 'Exciter position EBCC',
        message: 'Exciter beam center center',
      },
      EBCL: {
        notes: 'Exciter position EBCL',
        message: 'Exciter beam center left',
      },
      EBCR: {
        notes: 'Exciter position EBCR',
        message: 'Exciter beam center right',
      },
      EBDC: {
        notes: 'Exciter position EBDC',
        message: 'Exciter beam discharge center',
      },
      EBDL: {
        notes: 'Exciter position EBDL',
        message: 'Exciter beam discharge left',
      },
      EBDR: {
        notes: 'Exciter position EBFR',
        message: 'Exciter beam discharge right',
      },
      EBFC: {
        notes: 'Exciter position EBFC',
        message: 'Exciter beam feed center',
      },
      EBFL: {
        notes: 'Exciter position EBFL',
        message: 'Exciter beam feed left',
      },
      EBFR: {
        notes: 'Exciter position EBFR',
        message: 'Exciter beam feed right',
      },
      EBC: {
        notes: 'Exciter position EBR',
        message: 'Exciter beam center',
      },
      EBL: {
        notes: 'Exciter position EBL',
        message: 'Exciter beam left',
      },
      EBR: {
        notes: 'Exciter position EBR',
        message: 'Exciter beam right',
      },
    },
  },
  bearing: {
    notes: 'Bearing for an exciter',
    message: 'Bearing',
  },
};
